/**
 * @generated SignedSource<<9cd7ea80550e0d4ffef95be68d71e3c0>>
 * @relayHash 7d0c25385faa75cf03c6ce5788fcf340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d3cb3ffcb67d2d57776d48e9be0b15cebea988dcd6b48eb1a749a15a811c227

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewInternalsQuery$variables = {
  helpCenterAri: string;
  isVersioningEnabled: boolean;
};
export type AgentOverviewInternalsQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview">;
    } | null | undefined;
    readonly agents?: ReadonlyArray<{
      readonly versions?: {
        readonly nodes: ReadonlyArray<{
          readonly versionType: string | null | undefined;
        }>;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"multiVersionAgentSummary_AtlassianCsmAgentOverview">;
    }> | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type AgentOverviewInternalsQuery = {
  response: AgentOverviewInternalsQuery$data;
  variables: AgentOverviewInternalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVersioningEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "versionType"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v3/*: any*/),
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "CsmAiAgentVersion",
                                  "kind": "LinkedField",
                                  "name": "nodes",
                                  "plural": true,
                                  "selections": [
                                    (v4/*: any*/)
                                  ]
                                },
                                "action": "THROW",
                                "path": "csmAi_getAiHubByHelpCenterAri.agents.versions.nodes"
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCsmAiMultiVersionAgentResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "agentId"
                          },
                          {
                            "args": (v3/*: any*/),
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CsmAiAgentVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionNumber"
                                  },
                                  (v4/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "agentIdentityConfig",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "type": "CsmAiAgentIdentity"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "message"
                                          }
                                        ],
                                        "type": "QueryError"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2d3cb3ffcb67d2d57776d48e9be0b15cebea988dcd6b48eb1a749a15a811c227",
    "metadata": {},
    "name": "AgentOverviewInternalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bf1978c12f6bdbd4c2e71421e837944b";

export default node;
